import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Input from '../shared/Input';
import { fetchFormData } from '../../utils/options';
import topTost from '../../utils/topTost';

const CPContent = () => {
    const navigate = useNavigate();

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (newPassword !== confirmPassword) {
            topTost({
                title: "New Password and Confirm Password do not match.",
                icon: "error",
            });
            setIsSubmitting(false);
            return;
        }

        const formData = new FormData();
        formData.append("old_password", oldPassword);
        formData.append("new_password", newPassword);
        formData.append("confirm_password", confirmPassword);

        try {
            const res = await fetchFormData("change-password", formData, "POST");

            if (res && res.message === 'Password changed successfully') {
                topTost({
                    title: res.message,
                    icon: "success",
                });
                navigate('/dashboard');
            } else {
                topTost({
                    title: res?.message || "Failed to change password",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Submit error:", error);
            topTost({
                title: "Something went wrong. Please try again.",
                icon: "error",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const renderPasswordField = (label, name, value, onChange, show, toggleShow) => (
        <div className="position-relative">
            <Input
                label={label}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={label}
                type={show ? "text" : "password"}
                required
            />
            <span
                className="position-absolute top-50 end-0 translate-middle-y me-3"
                onClick={toggleShow}
                style={{ cursor: 'pointer', zIndex: 10 }}
            >
                {show ? <FaEyeSlash /> : <FaEye />}
            </span>
        </div>
    );

    return (
        <div className="col-lg-12">
            <div className="card stretch stretch-full">
                <hr className="mt-0" />
                <div className="card-body general-info">
                    <div className="mb-5 d-flex align-items-center justify-content-between">
                        <h5 className="fw-bold mb-0 me-4">
                            <span className="d-block mb-2">Change Password</span>
                        </h5>
                    </div>

                    <form onSubmit={handleSubmit} className="row g-3">
                        <div className="col-md-4">
                            {renderPasswordField("Old Password", "old_password", oldPassword, (n, v) => setOldPassword(v), showOld, () => setShowOld(!showOld))}
                        </div>
                        <div className="col-md-4">
                            {renderPasswordField("New Password", "new_password", newPassword, (n, v) => setNewPassword(v), showNew, () => setShowNew(!showNew))}
                        </div>
                        <div className="col-md-4">
                            {renderPasswordField("Confirm Password", "confirm_password", confirmPassword, (n, v) => setConfirmPassword(v), showConfirm, () => setShowConfirm(!showConfirm))}
                        </div>
                        <div className="customButton">
                            <button type="submit" className="btn btn-lg btn-primary" disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Change Password'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CPContent;
